export function sortparams(a, b) {
  var nameA = a.fParameter;
  var nameB = b.fParameter;

  if (nameA == nameB) return 0;
  else if (nameA < nameB) return -1;

  return 1;
}
